import SmsCheckUI from '../ui/sms-check-ui';
import SmsCheckService from '../data/sms-check-service';
import TrackLoginEvent from '../ui/track-login-event';

export default function () {
    SmsCheckService.attachTo(document);
    SmsCheckUI.attachTo(document);
    TrackLoginEvent.attachTo(document);
}
